import React, {Component} from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Button from '../../../shared/components/Button';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';


import { alphabeticallySort,textContains } from '../../../shared/utils';
import moment from "moment";

class MilestonesList extends Component {
  constructor(props){
    super(props);

    this.state = {
      isLoading:false
    }
  }

  componentDidMount(){
    this.setState({isLoading:true});
      this.props.loadMilestones()
      .then(() => this.setState({isLoading:false}))
      .catch(() => this.setState({isLoading:false}));
  }

  render(){
    const { milestones, updateMilestone } = this.props;
    if (this.state.isLoading) {
        return <div>Loading...</div>
    }
      const endMenu = (id) => ({
          text:'End Milestone',
          confirmationText:'This is permanent and can not be reverted.',
          confirmationAcceptText:'Confirm',
          confirmationRejectText:'Cancel',
          onClick:() => updateMilestone(id, {status: 'EXPIRED'})
      })

    return (
        <div>
          <Row>
            <Col xs='12'>
              <SearchableDataTable
                  items={milestones}
                  searchPromptText='Search by name'
                  emptyText='There are no messages'
                  columns={[
                    {
                      display: 'Message Name',
                      name:'name',
                      width:20,
                      sortFunc:(a,b) => alphabeticallySort(a.name,b.name),
                      filterFunc:(a,searchParam) => textContains(a.name,searchParam),
                      renderCell:(item) => (
                          <div>
                              <Link to={`${this.props.match.url}/${item.id}`}>{item.name}</Link>
                          </div>
                      )
                    },
                    {
                      name:'status',
                      width:10,
                      renderCell:(item) => (
                          <div>
                            <span>{item.status}</span>
                          </div>
                      )
                    },
                    {
                      name:'startDate',
                      display:'Start Date',
                      width:15,
                      sortFunc:(a,b) => a.startDate - b.startDate,
                      renderCell:(item) => <span>{moment(item.startDate).format('MMM D, YYYY')}</span>
                    },
                    {
                      name:'expirationDate',
                      display:'Expiration Date',
                      width:15,
                      sortFunc:(a,b) => a.expirationDate - b.expirationDate,
                      renderCell:(item) => <span>{moment(item.expirationDate).format('MMM D, YYYY')}</span>
                    },{
                          name:'views',
                          display:'Views',
                          width:10,
                          renderCell:(item) => (
                              <div>
                                  <span>{item.views}</span>
                              </div>
                          )
                      },{
                      width:20,
                      renderCell:(item) => (
                          <div className='pull-right'>
                              <Button
                                  size='sm'
                                  linkHref={`${this.props.match.url}/${item.id}`}
                                  textColor='#666666'
                                  borderColor='#cccccc'
                                  backgroundColor='#fff'
                              >
                                  Edit
                              </Button>

                              &nbsp;&nbsp;
                              {(item.status === 'ACTIVE' || item.status === 'READY') &&
                              <DropdownButton
                                  options={[endMenu(item.id)]}
                              />
                              }
                          </div>
                      )
                    }
                  ]}
              />
              <br />
              <br />
              <br />
            </Col>
          </Row>
        </div>
    )
  }
}

export default MilestonesList;



// WEBPACK FOOTER //
// ./src/routes/MilestonesList/components/MilestonesList.js